import React from "react";
import { useParams } from "react-router-dom";

import Landing from "./Landing";

// fetchingm
import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";

const ServiceDetailes = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const { slug } = useParams();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`services/${slug}`);
      setData(data?.servicesBySlug);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [slug]);

  if (isLoading) return <IsLoading />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Landing data={data} />
      </main>
    );
  }
};

export default ServiceDetailes;
